import { useState } from 'react';
import { useAuth } from '@/contexts/auth-context';
import { toast } from '@/hooks/use-toast';

export const useBangCanDoiPhatSinhCongNoExport = (queryParams?: BanHangSearchParams) => {
  const [isExporting, setIsExporting] = useState(false);
  const { entity } = useAuth();

  const exportToExcel = async () => {
    if (!entity?.slug) {
      toast({
        description: 'Không tìm thấy thông tin đơn vị.',
        variant: 'default'
      });
      return;
    }

    setIsExporting(true);
    try {
      const { exportBangCanDoiPhatSinhCongNoFromApi } = await import('../utils/excel-export');
      await exportBangCanDoiPhatSinhCongNoFromApi({
        entitySlug: entity.slug,
        queryParams
      });
    } catch (error) {
      toast({
        description: 'Không thể kết xuất dữ liệu.',
        variant: 'destructive'
      });
    } finally {
      setIsExporting(false);
    }
  };

  return {
    exportToExcel,
    canExport: Boolean(entity?.slug && queryParams),
    isExporting
  };
};
